<div [tooltip]="value? ( switchOptionOffTooltipText | translate ) : ( switchOptionOnTooltipText | translate ) ">
<div class="{{value?'switchOnCls':(hovered?'switchOffHoverCls':'switchOffCls')}}"
     (click)="onSwitch()"
     attr.data-testid="{{testId}}">
</div>
<span *ngIf="!!label" [width]="5"></span>
    <span *ngIf="!!label" class="{{labelClass}}">{{label | translate}}</span>
</div>